/**
 * Extract a human-readable error message from an unknown error.
 * Works with Axios errors, standard Error objects, and strings.
 */
export function getErrorMessage(error: unknown, fallback = 'An error occurred'): string {
  if (typeof error === 'string') return error;

  if (error instanceof Error) {
    // Axios error shape
    const axiosError = error as Error & {
      response?: { data?: { error?: string; message?: string } };
    };
    return (
      axiosError.response?.data?.error ||
      axiosError.response?.data?.message ||
      error.message ||
      fallback
    );
  }

  return fallback;
}
